module.exports = __webpack_public_path__ + "static/media/satellite.aa42c009.svg";